/* eslint-disable import/prefer-default-export */
import { writable } from 'svelte/store';

export const selectedDropdown = writable('');
export const selectedAudience = writable('');
export const selectedSolution = writable('');
export const selectedIndustry = writable('');
export const selectedChildIndustry = writable('');
